// @flow
import * as React from 'react';
import styled from 'styled-components';

const LabelText = styled.span`
  display: flex;
  justify-content: space-between;

  color: ${props => props.theme.V3.colors.text.formLabel};      
  font-weight: bold;
  font-size: ${props => props.theme.V3.fonts.forms.label.size}px;
  letter-spacing: ${props => props.theme.V3.fonts.forms.label.letterSpacing}px;
`;

const LabelElement = styled.div`
  margin-top: ${props => props.theme.V3.metrics.margin.small}px;
`;

interface Props {
  label: string | React.Element<any> ;
  name: string;

  children?: React.Node;
}

function LabeledInput({ label, name, children }: Props) {
  return (
    <label htmlFor={name}>
      <LabelText>{label}</LabelText>
      <LabelElement>{children}</LabelElement>
    </label>
  );
}

export default LabeledInput;



// WEBPACK FOOTER //
// ./src/statsradio/components/ui/forms/LabeledInput.js